function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  // document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
  document.querySelectorAll('product-model').forEach((model) => ((model.modelViewerUI === null || model.modelViewerUI === undefined) ? undefined : model.modelViewerUI.pause()));
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    // this.querySelector('.template-popup')?.loadContent();
    if (this.querySelector('.template-popup') === null || this.querySelector('.template-popup') === undefined) {

    } else {
      this.querySelector('.template-popup').loadContent();
    }
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    // button?.addEventListener('click', () => {
    //   document.querySelector(this.getAttribute('data-modal'))?.show(button);
    // });
    if (button === null || button === undefined) {

    } else {
      button.addEventListener('click', () => {
        // document.querySelector(this.getAttribute('data-modal'))?.show(button);
        (document.querySelector(this.getAttribute('data-modal')) === null || document.querySelector(this.getAttribute('data-modal')) === undefined) ? undefined : document.querySelector(this.getAttribute('data-modal')).show(button);
      });
    }
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    // this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
    if (this.querySelector('[id^="Deferred-Poster-"]') === null || this.querySelector('[id^="Deferred-Poster-"]') === undefined) {

    } else {
      this.querySelector('[id^="Deferred-Poster-"]').addEventListener('click', this.loadContent.bind(this));
    }
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    // if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    // const newMedia = document.querySelector(
    //   `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    // );
    if (!this.currentVariant || !((this.currentVariant === null || this.currentVariant === undefined) ? undefined : this.currentVariant.featured_media)) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0); });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    // if (this.currentVariant?.available) {
    //   pickUpAvailability.fetchAvailability(this.currentVariant.id);
    // } else {
    //   pickUpAvailability.removeAttribute('available');
    //   pickUpAvailability.innerHTML = '';
    // }
    if (((this.currentVariant === null || this.currentVariant === undefined) ? undefined : this.currentVariant.available)) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        // document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        if (document.getElementById(`price-${this.dataset.section}`) === null || document.getElementById(`price-${this.dataset.section}`) === undefined) {

        } else {
          document.getElementById(`price-${this.dataset.section}`).classList.remove('visibility-hidden');
        }

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    // const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const addButton = (document.getElementById(`product-form-${this.dataset.section}`) === null || document.getElementById(`product-form-${this.dataset.section}`) === undefined) ? undefined : document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    // const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const addButton = (document.getElementById(`product-form-${this.dataset.section}`) === null || document.getElementById(`product-form-${this.dataset.section}`) === undefined) ? undefined : document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');

    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;

    // document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
    if (document.getElementById(`price-${this.dataset.section}`) === null || document.getElementById(`price-${this.dataset.section}`) === undefined) {

    } else {
      document.getElementById(`price-${this.dataset.section}`).classList.add('visibility-hidden');
    }

  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


/****************************
  MEDIA BREADCRUMB
  ****************************/


// calculate current dot active in product media breadcrumb
function calculateMediasBreadcrumb() {
  var distanceToTop = $(window).scrollTop();
  var currentMediaIndex = 0;

  $('[data-product-media]').each(function (i) {
    var elTop = $(this).offset().top;
    if (distanceToTop > (elTop - 50)) {
      currentMediaIndex = i;
    }
  });
  $('[data-product-media-breadcrumb-dot]').not(':eq(' + currentMediaIndex + ')').removeClass('active');
  $('[data-product-media-breadcrumb-dot]').eq(currentMediaIndex).addClass('active');
}
calculateMediasBreadcrumb();
$(window).scroll(function () {
  calculateMediasBreadcrumb();
});

// on click on product media breadcrumb dot, update current media
$('[data-product-media-breadcrumb-dot]').on('click', function () {
  var index = $(this).index();
  var scrollTo = $('[data-product-media]').eq(index).offset().top;
  $('html, body').animate({ scrollTop: scrollTo + 1 }, 400);
});


/****************************
   Accordion
  ****************************/

// Inspiration: https://www.w3.org/TR/wai-aria-practices/examples/accordion/js/accordion.js
// feature: data-allow-toggle
// Allow for each toggle to both open and close its section. Makes it possible for all sections to be closed. Assumes only one section may be open.

// feature: data-allow-multiple
// Allow for multiple accordion sections to be expanded at the same time. Assumes data-allow-toggle otherwise the toggle on open sections would be disabled.
// __________

// Ex:
// Parent
// <div id="accordionGroup" data-accordion>
// <div id="accordionGroup" data-accordion data-allow-multiple>
// <div id="accordionGroup" data-accordion data-allow-toggle></div>
//  Question
// <div data-accordion-trigger aria-expanded="true / false" aria-controls="#faq-group-{{- id -}}-{{- forloop.index -}}">
// Answer
// <div id="faq-group-{{- id -}}-{{- forloop.index -}}" data-accordion-panel>


(function () {
  'use strict';

  var selectors = {
    root: "[data-accordion]",
    trigger: "[data-accordion-trigger]",
    panel: "[data-accordion-panel]"
  };

  var features = {
    allow_multiple: "[data-allow-multiple]",
    allow_toggle: "[data-allow-toggle]"
  };

  var data = {
    target_id: 'aria-controls'
  };

  var states = {
    expanded: {
      attr_name: 'aria-expanded',
      attr_values: {
        yes: "true",
        no: "false"
      }
    },
    disabled: {
      attr_name: 'aria-disabled',
      attr_values: {
        yes: "true",
        no: "false"
      }
    }
  };

  $(selectors.root).each(function () {
    var $accordion = $(this);
    init($accordion);
  });

  function init($accordion) {
    var allowsMultiple = $accordion.is(features.allow_multiple);
    var options = {
      allowsMultiple: allowsMultiple,
      allowToggle: (allowsMultiple) ? allowsMultiple : $accordion.is(features.allow_toggle)
    };

    $accordion.on("click", selectors.trigger, function (e) {
      e.preventDefault();
      trigger($(this), $accordion, options);
    });

    $accordion.on('keydown', function (e) {
      handleKeyboard(event, $(this), options);
    });

    if (!options.allowToggle) {
      // Get the first expanded/ active accordion
      var $expanded = $accordion.find('[aria-expanded="true"]').first();

      // If an expanded/ active accordion is found, disable
      if ($expanded.length) {
        $expanded.setAttribute(states.disabled.attr_name, states.disabled.attr_values.yes);
      }
    } else {
      // Get all unexpanded accordion panels
      var $unexpanded = $accordion.find('[aria-expanded="false"]');
      $unexpanded.each(function () {
        var panelId = $(this).attr('aria-controls');
        hidePanel($(panelId));
      });
    }
  }

  function trigger($trigger, $accordion, options) {
    var settings = {
      allowsMultiple: options.allowsMultiple,
      allowToggle: options.allowToggle
    };

    var $targetPanel = $($trigger.attr(data.target_id));

    var isExpanded = $trigger.is("[" + states.expanded.attr_name + "='" + states.expanded.attr_values.yes + "']");
    var $accordionActiveTriggers = $accordion.find("[" + states.expanded.attr_name + "='" + states.expanded.attr_values.yes + "']");
    var $accordionActivePanels = $accordion.find(selectors.panel);

    if (!settings.allowsMultiple && $accordionActiveTriggers.length > 0) {
      // Set the expanded state on the triggering element
      $accordionActiveTriggers.not($trigger).attr(states.expanded.attr_name, states.expanded.attr_values.no);
      // Hide the accordion sections, using aria-controls to specify the desired section
      hidePanel($accordionActivePanels.not($targetPanel));

      // When toggling is not allowed, clean up disabled state
      if (!settings.allowToggle) {
        $accordionActiveTriggers.removeAttr(states.disabled.attr_name);
      }
    }

    if (!isExpanded) {
      // Set the expanded state on the triggering element
      $trigger.attr(states.expanded.attr_name, states.expanded.attr_values.yes);
      // Hide the accordion sections, using aria-controls to specify the desired section
      reveilPanel($targetPanel);

      // If toggling is not allowed, set disabled state on trigger
      if (!settings.allowToggle) {
        $trigger.attr(states.disabled.attr_name, states.disabled.attr_values.yes);
      }
    }
    else if (settings.allowToggle && isExpanded) {
      // Set the expanded state on the triggering element
      $trigger.attr(states.expanded.attr_name, states.expanded.attr_values.no);
      // Hide the accordion sections, using aria-controls to specify the desired section
      hidePanel($targetPanel);
    }
  }

  function reveilPanel($panel) {
    $panel.slideDown();// .removeClass('hide');
  }

  function hidePanel($panel) {
    $panel.slideUp(); //.addClass('hide');
  }

  function handleKeyboard(event, $accordion, options) { }
})();

// Dynamic translation custom
$(function () {
  if (Shopify && Shopify.locale && Shopify.locale == 'fr') {
    $('[data-text-translation-fr]').each(function () {
      $(this).html($(this).attr('data-text-translation-fr'));
    });
  }

});

// TODO LATER : use accordion with shortcuts (keyboard)
// Array.prototype.slice.call(document.querySelectorAll('.Accordion')).forEach(function (accordion) {

//     // Allow for multiple accordion sections to be expanded at the same time
//     var allowMultiple = accordion.hasAttribute('data-allow-multiple');
//     // Allow for each toggle to both open and close individually
//     var allowToggle = (allowMultiple) ? allowMultiple : accordion.hasAttribute('data-allow-toggle');

//     // Create the array of toggle elements for the accordion group
//     var triggers = Array.prototype.slice.call(accordion.querySelectorAll('.Accordion-trigger'));
//     var panels = Array.prototype.slice.call(accordion.querySelectorAll('.Accordion-panel'));


//     accordion.addEventListener('click', function (event) {
//         var target = event.target;

//         if (target.classList.contains('Accordion-trigger')) {
//             // Check if the current toggle is expanded.
//             var isExpanded = target.getAttribute('aria-expanded') == 'true';
//             var active = accordion.querySelector('[aria-expanded="true"]');

//             // without allowMultiple, close the open accordion
//             if (!allowMultiple && active && active !== target) {
//                 // Set the expanded state on the triggering element
//                 active.setAttribute('aria-expanded', 'false');
//                 // Hide the accordion sections, using aria-controls to specify the desired section
//                 document.getElementById(active.getAttribute('aria-controls')).setAttribute('hidden', '');

//                 // When toggling is not allowed, clean up disabled state
//                 if (!allowToggle) {
//                 active.removeAttribute('aria-disabled');
//                 }
//             }

//             if (!isExpanded) {
//                 // Set the expanded state on the triggering element
//                 target.setAttribute('aria-expanded', 'true');
//                 // Hide the accordion sections, using aria-controls to specify the desired section
//                 document.getElementById(target.getAttribute('aria-controls')).removeAttribute('hidden');

//                 // If toggling is not allowed, set disabled state on trigger
//                 if (!allowToggle) {
//                 target.setAttribute('aria-disabled', 'true');
//                 }
//             }
//             else if (allowToggle && isExpanded) {
//                 // Set the expanded state on the triggering element
//                 target.setAttribute('aria-expanded', 'false');
//                 // Hide the accordion sections, using aria-controls to specify the desired section
//                 document.getElementById(target.getAttribute('aria-controls')).setAttribute('hidden', '');
//             }

//             event.preventDefault();
//         }
//     });

//     // Bind keyboard behaviors on the main accordion container
//     accordion.addEventListener('keydown', function (event) {
//         var target = event.target;
//         var key = event.which.toString();

//         var isExpanded = target.getAttribute('aria-expanded') == 'true';
//         var allowToggle = (allowMultiple) ? allowMultiple : accordion.hasAttribute('data-allow-toggle');

//         // 33 = Page Up, 34 = Page Down
//         var ctrlModifier = (event.ctrlKey && key.match(/33|34/));

//         // Is this coming from an accordion header?
//         if (target.classList.contains('Accordion-trigger')) {
//         // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
//         // 38 = Up, 40 = Down
//         if (key.match(/38|40/) || ctrlModifier) {
//             var index = triggers.indexOf(target);
//             var direction = (key.match(/34|40/)) ? 1 : -1;
//             var length = triggers.length;
//             var newIndex = (index + length + direction) % length;

//             triggers[newIndex].focus();

//             event.preventDefault();
//         }
//         else if (key.match(/35|36/)) {
//             // 35 = End, 36 = Home keyboard operations
//             switch (key) {
//             // Go to first accordion
//             case '36':
//                 triggers[0].focus();
//                 break;
//                 // Go to last accordion
//             case '35':
//                 triggers[triggers.length - 1].focus();
//                 break;
//             }
//             event.preventDefault();

//         }

//         }
//     });

//     // These are used to style the accordion when one of the buttons has focus
//     accordion.querySelectorAll('.Accordion-trigger').forEach(function (trigger) {

//         trigger.addEventListener('focus', function (event) {
//         accordion.classList.add('focus');
//         });

//         trigger.addEventListener('blur', function (event) {
//         accordion.classList.remove('focus');
//         });

//     });

//     // Minor setup: will set disabled state, via aria-disabled, to an
//     // expanded/ active accordion which is not allowed to be toggled close
//     if (!allowToggle) {
//         // Get the first expanded/ active accordion
//         var expanded = accordion.querySelector('[aria-expanded="true"]');

//         // If an expanded/ active accordion is found, disable
//         if (expanded) {
//         expanded.setAttribute('aria-disabled', 'true');
//         }
//     }

// });



const form = document.querySelector('.form');

form.addEventListener('submit', (event) => {
  event.preventDefault();

  const spinner = document.querySelector('.spinner');
  const buttonText = document.querySelector('.button-text');

  spinner.style.display = 'block';
  buttonText.style.display = 'none';

  const submitButton = document.querySelector('.form-submit-button');
  submitButton.disabled = true;


  let totalPriceForm = 0;
  //Récupérer l'ID du client
  const sellerShopifyId = __st.cid || 0;

  // Récupérer le champ "Volume"
  const volume = form.querySelector('input[name="volume"]:checked').value;
  const volumePriceForm = parseFloat(form.querySelector('input[name="volume"]:checked').getAttribute("price"));
  totalPriceForm += volumePriceForm;

  // Récupérer le champ "Base"
  const base = form.querySelector('input[name="base"]:checked').id;

  const nutriBoxes = document.querySelectorAll(".nutri-box");
  let nutriData = {};

  nutriBoxes.forEach(nutriBox => {
    const img = nutriBox.querySelector(".nutri-image img");
    const quantityInput = nutriBox.querySelector(".quantity-input");
    const value = img.getAttribute("value");
    const quantity = quantityInput.value;
    const nutriPriceForm = parseFloat(quantityInput.getAttribute("price")) || 0;

    if (quantity > 0) {
      nutriData[value] = quantity;
      totalPriceForm += (quantity * nutriPriceForm);
    }
  });

  // Récupérer le champ "Dosage"
  const dosageSelect = document.getElementById('dosage');

  // Récupérer le champ "Name"
  const nameSelect = document.getElementById('name');

  // Récupérer le champ "FName"
  const fNameSelect = document.getElementById('fName');

  // Récupérer le champ "Intiales"
  const initialsSelect = document.getElementById('initials');

  // Récupérer le champ "Message"
  const messageSelect = document.getElementById('message');

  // Récupérer le champ "Mail"
  const customerMail = document.getElementById('customerMail');

  // Ajouter les données récupérées au corps de la requête
  const formData = {
    volume: volume,
    base: base,
    nutri: nutriData,
    dosage: dosageSelect.value,
    name: nameSelect.value,
    fName: fNameSelect.value,
    initials: initialsSelect.value,
    mail: customerMail.value,
    message: messageSelect.value,
    price: totalPriceForm,
    sellerShopifyId
  };

  fetch('https://codageparis.app.n8n.cloud/webhook/custom-serum-workflow', {
    method: 'POST',
    body: JSON.stringify(formData),
    redirect: 'follow'
  }).then(response => {

    setTimeout(() => {
      spinner.style.display = 'none';
      buttonText.style.display = 'block';
      submitButton.disabled = false;
    }, 3000);


    if (response.status === 301) {
      window.location.href = "https://www.codageparis.com/fr/account";
    } else if (response.status === 500) {
      alert("Error creating made to measure");
    }
    console.log(response);
  }).catch(error => {
    spinner.style.display = 'none';
    buttonText.style.display = 'block';
    submitButton.disabled = false;
    console.error(error);
  });
});


const getTotalQuantity = () => {
  let total = 0;
  document.querySelectorAll('.quantity-input').forEach((input) => {
    total += parseInt(input.value);
  });
  return total;
};

const updateTotalNutri = () => {
  const totalQuantity = parseInt(getTotalQuantity());
  const totalNutriSpan = document.querySelector('.total-nutri');
  const totalNutriSpanMobile = document.querySelector('.total-nutri-mobile');
  totalNutriSpan.textContent = totalQuantity.toFixed(0);
  totalNutriSpanMobile.textContent = totalQuantity.toFixed(0);
};

const updateSelectedNutriList = () => {
  const nutriBoxes = document.querySelectorAll(".nutri-box");
  let nutriList = [];

  nutriBoxes.forEach(nutriBox => {
    const img = nutriBox.querySelector(".nutri-image img");
    const quantityInput = nutriBox.querySelector(".quantity-input");
    const value = img.getAttribute("value");
    const quantity = parseInt(quantityInput.value);

    if (quantity > 0) {
      nutriList.push(`${value} x ${quantity}`);
    }
  });

  const nutriListSpan = document.querySelector('.nutri-list');
  nutriListSpan.textContent = nutriList.join(', ');
};

const updateButtonsState = (inputField, increaseButton) => {
  if (parseInt(inputField.value) >= parseInt(inputField.max)) {
    increaseButton.classList.add('disabled');
  } else {
    increaseButton.classList.remove('disabled');
  }
};

const updateTotalPrice = () => {
  let totalPrice = 0;

  const selectedVolumePrice = document.querySelector('input[name="volume"]:checked').getAttribute('price');
  totalPrice += parseFloat(selectedVolumePrice);

  document.querySelectorAll('.quantity-input').forEach((input) => {
    const nutriPrice = (parseInt(input.getAttribute('price')) || 0) * parseInt(input.value);
    totalPrice += nutriPrice;
  });

  const totalSpan = document.querySelector('.total-price');
  const totalSpanMobile = document.querySelector('.total-price-mobile');
  totalSpan.textContent = totalPrice.toFixed(2);
  totalSpanMobile.textContent = totalPrice.toFixed(2);
};

updateTotalPrice();

const decreaseQuantity = (inputField, increaseButton) => {
  if (parseInt(inputField.value) > parseInt(inputField.min)) {
    inputField.value = parseInt(inputField.value) - 1;
    updateButtonsState(inputField, increaseButton);
    updateTotalPrice();
    updateTotalNutri();
    updateSelectedNutriList();
  }
};

const increaseQuantity = (inputField, increaseButton) => {
  if (parseInt(inputField.value) < parseInt(inputField.max)) {
    const currentTotal = getTotalQuantity();
    if (currentTotal < 18) {
      inputField.value = parseInt(inputField.value) + 1;
      updateButtonsState(inputField, increaseButton);
      updateTotalPrice();
      updateTotalNutri();
      updateSelectedNutriList();
    } else {
      alert("Vous ne pouvez pas ajouter plus de 18 nutri & booster à votre Serum. You can't add more than 18 nutri & booster to your Serum.");
    }
  }
};

document.querySelectorAll('.quantity-controls').forEach((control) => {
  const decreaseButton = control.querySelector('.quantity-decrease');
  const increaseButton = control.querySelector('.quantity-increase');
  const inputField = control.querySelector('.quantity-input');

  updateButtonsState(inputField, increaseButton);

  decreaseButton.addEventListener('click', () => {
    decreaseQuantity(inputField, increaseButton);
  });

  increaseButton.addEventListener('click', () => {
    increaseQuantity(inputField, increaseButton);
  });
});

const updateStickyDiv = () => {
  const selectedBase = document.querySelector('input[name="base"]:checked').value;
  const stickyBaseSpan = document.querySelector('.sticky-base');
  const stickyVolumeSpan = document.querySelector('.sticky-volume');

  const volumeInputs = document.querySelectorAll('input[name="volume"]');
  volumeInputs.forEach(input => {
    if (input.checked) {
      const volumeText = input.parentNode.querySelector('.volume-text').textContent;
      stickyVolumeSpan.textContent = volumeText;
    }
  });

  stickyBaseSpan.textContent = selectedBase;

  updateTotalPrice();
};

updateStickyDiv();

document.querySelectorAll('.sticky-selector').forEach((block) => {
  block.addEventListener('click', () => {
    updateStickyDiv();
  });
});

const orderNotes = document.querySelector('.chContent-BPCW-Order--Notes');
orderNotes.addEventListener('click', () => {
  alert("Test");
});


function markOrderAsPrepared (orderId) {
  const apiEndpoint = `https://codageparis.app.n8n.cloud/webhook/mark-as-prepared?orderId=${orderId}`;

  fetch(apiEndpoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then((response) => {
      if (response.ok) {
        console.log('Order marked as prepared successfully');
      } else {
        console.error('Error marking order as prepared:', response.status, response.statusText);
      }
    })
    .catch((error) => {
      // Request failed
      console.error('Network error occurred while marking order as prepared', error);
    });
};

